var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 584.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-6{fill:#152a4e}\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -7252.69,
    y1: -4151.43,
    x2: -7400.06,
    y2: -4025.96,
    gradientTransform: "rotate(-130.69 -2037.629 -3865.032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d73ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4b72fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#4471fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#396df8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2868f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1262ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -7295.56,
    y1: -4030.59,
    x2: -7361.29,
    y2: -3974.62,
    gradientTransform: "rotate(-130.69 -2037.629 -3865.032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6687ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#6687ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#6687ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#6687ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6687ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -7361.16,
    y1: -3874.11,
    x2: -7100.35,
    y2: -3875.98,
    gradientTransform: "rotate(-130.69 -2037.629 -3865.032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ee6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#276ef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#497bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5e84fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#6687ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#6386fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#5881fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#467af7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2d6ff1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0d62e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -7230.34,
    y1: -3953.99,
    x2: -7051.75,
    y2: -4106.04,
    gradientTransform: "rotate(-130.69 -2037.629 -3865.032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094fed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0a4eea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0d4cdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1147cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1841b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f3b99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -7043.16,
    y1: -4143.03,
    x2: -7160.49,
    y2: -4043.13,
    gradientTransform: "rotate(-130.69 -2037.629 -3865.032)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#365ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#325ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#1749ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#063fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003b99"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1160 181l4.88.47c35.24 3.39 70.54 6.37 105.63 11.12 6.63 26.55 10.89 49.25 16.87 61.54 16.23 33.44 47 21.61 55.84 7.81l-7 19c-8 21.63-16.1 43.23-24 64.89-9.18 25.2-26.06 55.51-57.85 50.51-27.4-4.3-38.14-34.52-45-57.67-11.64-39.37-18.85-79.21-32.38-118A313.14 313.14 0 0 0 1160 181z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1270.51 192.55c74.13 10 79.24 43.1 79.33 51.47q-3.33 8.94-6.62 17.88c-8.84 13.8-39.61 25.63-55.84-7.81-5.98-12.29-10.24-34.99-16.87-61.54z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1180.8 45.37L1440 0l-.26.71-.51 1.41-.23.63-.55 1.5-.29.79-8.78 23.7L1403 100q-16.89 45.72-33.8 91.48-9.71 26.25-19.4 52.51c-.09-8.37-5.2-41.43-79.33-51.47-12.47-49.97-33.3-113.63-89.67-147.15z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.63 67.8l128.17-22.43c56.37 33.52 77.23 97.18 89.71 147.18-35.09-4.75-70.39-7.73-105.63-11.12L1160 181a319.71 319.71 0 0 0-53.84-75.85c-3.78-3.91-7.7-7.67-11.79-11.24 0-.04-23.62-20.62-41.74-26.11z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.68 67.81c18.12 5.49 41.69 26.06 41.69 26.06 4.09 3.57 8 7.33 11.79 11.24A319.71 319.71 0 0 1 1160 181c-30.52-2.82-62.08-5-91.86-12.16-24-5.81-44.66-20.87-51.05-45.6-5.12-19.82 2.41-39 20.23-49.38a58.4 58.4 0 0 1 15.31-6",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.69 291.76q-42.18 0-71.72 21.66t-36.28 57.1L69.75 384q10.68-32.62 48.94-32.63 49.5 0 49.5 41.63v12.37h-47.25q-54 0-87.47 25.32T0 498.21q0 40 23.91 63t62.16 23.06q54.56 0 87.19-40.5l7.31 36H238V410.46q0-118.68-119.31-118.7zm49.5 174.39q0 25.88-20.25 42.19a69.31 69.31 0 0 1-45.56 16.31q-13.5 0-21.38-7.87a26.72 26.72 0 0 1-7.87-19.69q0-36.57 48.38-36.57h46.68zM307.14 181.51h69.75v398.27h-69.75zM610.34 517.9a55.54 55.54 0 0 1-27 6.75q-19.12 0-28.12-10.69t-9-35.44V355.89H621v-59.63h-74.79V181.51l-69.76 43.88v70.87h-43.87v59.63h43.87v123.76q0 51.2 27.29 77.91t76.78 26.72a108.71 108.71 0 0 0 46.13-10.13zM716.09 259.7q19.11 0 32.06-12.94t12.94-32.06q0-19.12-12.94-32.06t-32.06-12.94q-19.09 0-32.09 12.94t-12.91 32.06q0 19.13 12.94 32.06t32.06 12.94zM681.21 296.26h69.75v283.52h-69.75zM1004.1 443.65Q999 436.9 983.85 429q-16.32-9-20.25-10.69l-24.19-8.44-20.25-7.3q-27-10.14-27-27.57 0-11.25 7.31-17.44t18.53-6.17q27.56 0 47.25 24.76l41.63-38.26q-13.5-20.81-37.41-33.47A108.47 108.47 0 0 0 918 291.76q-40.5 0-65.25 24.2-25.32 24.18-25.31 58.5 0 29.25 14.34 46.69t43 29.81q4.5 1.69 19.69 7.32t20.25 7.87a77.07 77.07 0 0 1 15.75 6.75q15.19 7.32 15.19 21.38 0 30.38-34.88 30.37-39.88 0-56.78-46.65l-55.69 29.82q12.93 30.94 42.19 53.44 29.81 23.07 70.31 23.06 45 0 72.57-27.56 28.13-28.12 28.13-66.94a67.4 67.4 0 0 0-17.41-46.17z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.709577c490b1ce4a56a3349ce585fb53.svg";
export { ForwardRef as ReactComponent };